// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// es6
// require('es6-promise').polyfill()
import "babel-polyfill"

// 
import 'mint-ui/lib/style.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 引入公共common.css
import '../static/css/common.css'
// 引入iconfont.css
import '../static/css/iconfont.css'

import Vue from 'vue'
import App from './App'
import router from './router'
//vuex
import store from './store'

Vue.use(ElementUI)

// 引入打印
import Print from 'vue-print-nb'
Vue.use(Print)

// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store, //使用store
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js